import type {TApiResponse} from "modules/types";

/**
 * Custom Errors handler
 */
export class ApiError extends Error {
	public static readonly AUTH_REQUIRED = 401;
	public static readonly SERVER_ERROR = 502;
	// public static USER_EXPIRED_TOKEN = 510;
	public static readonly USER_NOT_REGISTERED = 513;
	public code?: number;

	constructor(m: string, code = 0) {
		super(m);
		this.name = "API Error";
		this.message = m;
		this.code = code;
	}

	public static HAS_ERROR({errors}: TApiResponse) {
		return Boolean(Array.isArray(errors) && errors.length);
	}

	/**
	 * Should be called after each requests when we expect some errors or validations
	 */
	public static CHECK(response: TApiResponse) {
		if (ApiError.HAS_ERROR(response)) {
			const error = response.errors[0];
			throw new ApiError(error.message, error.code);
		}
	}
}

export default ApiError;
